import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import {
   BehaviorSubject,
   distinctUntilChanged,
   from,
   map,
   Observable,
   pairwise
} from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { PermissionsService } from '../permissions.service';
import { UserPermissions } from '../../domain/security/user-permissions';

@Injectable({ providedIn: 'root' })
export class PermissionsStoreService {
   private cached$?: Observable<UserPermissions>;

   private readonly refresh$ = new BehaviorSubject<void>(undefined);

   private readonly permissions$ = this.refresh$.pipe(
      switchMap(() => from(this.permissionsService.getPermission())),
      // singleton store: keeping refCount false is fine (source completes anyway)
      shareReplay({ bufferSize: 1, refCount: false })
   );
   constructor(
      private permissionsService: PermissionsService,
      private auth: AuthService
   ) {
      // Invalidate on logout
      this.auth.isAuthenticated$.pipe(distinctUntilChanged()).subscribe((isAuth) => {
         if (!isAuth) this.invalidate();
      });

      // Invalidate ONLY when the user actually changes (sub changes)
      this.auth.user$
         .pipe(
            map((u) => u?.sub ?? null),
            distinctUntilChanged(),
            pairwise()
         )
         .subscribe(([prev, curr]) => {
            if (prev && curr && prev !== curr) this.invalidate();
         });
   }

   get(): Observable<UserPermissions> {
      return this.permissions$;
   }

   invalidate(): void {
      this.permissionsService.clearLocalCache();
      this.refresh$.next();
   }
}
